import useEventListener from '@use-it/event-listener'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FiTrash2 } from 'react-icons/fi'
import { GrStatusGood } from 'react-icons/gr'
import { HiOutlineX } from 'react-icons/hi'
import Button from '../General/Button'
import Modal from './Modal'

/**
 * Componente de confirmModal para mostrar un modal en caso de que se requiera un mensaje
 * de confirmacion previo
 * @param {string} title se encarga de mostrar el titulo del confirmModal.
 * @param {boolean} displayConfirmModal boolean que muestra u oculta el modal.
 * @param {Function} onCancel funcion que se acciona al momento de presionar el boton de cancelar.
 * @param {Function} onConfirm function que se accion al momento de presuonar el boton de aceptar.
 * @param {string} modalClasses string que asigna las clases del modal.
 * @param {boolean} positive boolean que cambia el color del boton dependiendo del accionar.
 */

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  title,
  displayConfirmModal,
  onCancel,
  onConfirm,
  isInfo = false,
  normalClasses = '',
  xlClasses = 'xl:w-96',
  lgClasses = '',
  positive = false,
  body = '',
}): JSX.Element => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const [selectedButton, setSelectedButton] = useState('ArrowLeft')

  const selectedButtonRef = useRef('ArrowLeft')

  const completeClose = () => {
    onCancel()
    setSelectedButton('ArrowLeft')
    selectedButtonRef.current = 'ArrowLeft'
  }

  useEffect(() => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.autofocus = true
    }
  }, [])

  useEventListener('keydown', (event: any) => {
    console.log("llega")
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      selectedButtonRef.current = event.key
      setSelectedButton(event.key)
    }
    if (event.key === 'Enter') {
      if (selectedButtonRef.current === 'ArrowRight') {
        onConfirm && onConfirm()
        setSelectedButton('ArrowLeft')
         selectedButtonRef.current = 'ArrowLeft'
      } else {
        completeClose()
      }
    }
  })

  return (
    <>
      <Modal
        display={displayConfirmModal}
        onClose={() => completeClose()}
        xlClasses={xlClasses}
        normalClasses={normalClasses}
        lgClasses={lgClasses}
        innerStyle={{ padding: 15 }}
      >
        <div className="text-base dark:text-primary-200 text-primary-1300 text-center">
          {title}
        </div>
        <div className="mt-4 text-sm dark:text-white text-dark">{body}</div>

        { (!isInfo || onConfirm) && (
            <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>
        )}

        <div className="flex flex-row justify-center mt-4">
          <div className="flex flex-row justify-around w-72">
            {!isInfo && (
              <Button
                classes="rounded w-5/12"
                style={{
                  border:
                    selectedButton === 'ArrowLeft' ? '2px solid #00C2FF' : '',
                }}
                // style={returnStyle('ArrowLeft')}
                // style={{ color: 'white' }}
                type="outline"
                onClick={() => completeClose()}
              >
                Cancelar
              </Button>
            )}
            {onConfirm && (
              <Button
                // style={returnStyle('ArrowRight')}
                style={{
                  border:
                    selectedButton === 'ArrowRight' ? '2px solid #00C2FF' : '',
                }}
              classes="rounded w-5/12"
              type="primary"
                // style={{borderColor: '#D32F2F' }}
                onClick={() => onConfirm()}
              >
                Confirmar
              </Button>
            )}
            {/* <button ref={buttonRef}>Confirmar</button> */}
          </div>
        </div>
      </Modal>
    </>
  )
}

interface ModalConfirmProps {
  title: string
  displayConfirmModal: boolean
  onCancel: Function
  onConfirm?: Function
  normalClasses?: string
  xlClasses?: string
  lgClasses?: string
  positive?: boolean
  isInfo?: boolean
  body?: string
}

export default ModalConfirm
